/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline, TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodBigWinCountUp} from "./DeadwoodBigWinCountUp";
import {DeadwoodBigWinView} from "./DeadwoodBigWinView";

export class DeadwoodBigWinController extends StepCountUpBigWinController {

    private _gameView:DeadwoodBigWinView;
    private _winCountUp:DeadwoodBigWinCountUp;

    constructor(indexes:[number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall : true,
            skippableOnEachLevel: true
        });

        this._gameView = new DeadwoodBigWinView();
        this._winCountUp = new DeadwoodBigWinCountUp();
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.65);
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        const timeline:Timeline = this._gameView.getBigWinLevelAnimation(level, this._winRatios[level]);
        timeline.add(TweenLite.fromTo(this._winCountUp.scale, this._winRatios[level].duration, {
            x : 0.8,
            y : 0.8
        }, {x : 1, y : 1}), 0);
        return timeline
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.BIG_WIN_ENDS);
        SlotGame.sound.fadeAmbience(1, 4000);
        this._gameView.playEndingAnimation(this._winLevel, isAborted);
        SlotGame.winFieldController.showWinField();
        this._winCountUp.scale.set(1);
        this._winCountUp.abort(this._gameData!.singleWin, isAborted);
    }

    protected playBigWinSound():void {
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.BIG_WIN);
        SlotGame.sound.fadeAmbience(0, 1300);
    }

    protected playBigWinLevelSound(level:number):void {
        SlotGame.sound.playEffect((<any>DeadwoodSoundConfig.instance)[`BIG_WIN_${level}`]);
    }

    protected abortCurrentLevel(level:number):void {
        super.abortCurrentLevel(level);
        for(let i:number = 0; i <= level; i++) {
            SlotGame.sound.stopEffect((<any>DeadwoodSoundConfig.instance)[`BIG_WIN_${i}`]);
        }
    }

    protected stopAllSounds():void {
        SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.BIG_WIN_0);
        SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.BIG_WIN_1);
        SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.BIG_WIN_2);
        SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.BIG_WIN_3);
        SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.BIG_WIN);
    }
}